export default __webpack_public_path__ + "static/media/06.53d26aba.jpg";